<template>
  <div class="app-teaser" id="akquiseapp">
    <transition name="fade">
      <videoModal v-if="ui.showVidModal" @close="ui.showVidModal = false" :video="'M5x5D1lqzB4'">

      </videoModal>
    </transition>
    <div class="section-1">
      <div class="grid-container p-120">
        <div class="grid-x grid-margin-x">
          <div class="cell large-4 large-offset-2">
            <h2 class="title-2">Sprechen Sie junge Menschen ganz einfach an:
              <br class="hide-for-small-only">Mit Ihrer eigenen App rund um die Arbeitskraft.</h2>
            <p class="teaser-text">
              Sie wissen es selbst: Das beste Produkt hilft 
              nichts, wenn Sie die passenden Kunden nicht 
              erreichen. Deshalb präsentiert die neue ERGO 
              BU „Thores Change Your Life-Challenge“ – <strong>die 
              neutral gestaltete Akquise-App, die Sie mit 
              Ihren Daten individualisieren und so zu Ihrer 
              ganz eigenen App machen können.</strong>
            </p>
            <p class="teaser-text">
              Die App unterstützt Sie dabei, junge Menschen 
              online zum Thema Arbeitskraft anzusprechen – 
              <strong> bestenfalls direkt für Ihre unabhängige 
              Beratung zu gewinnen.</strong>
            </p>
          </div>
          <div class="cell large-4">
            <img class="app-teaser" src="@/assets/Handy_Screen-Final_App.jpg" />
            <!--div class="btn big-red"><span>Mehr erfahren zu Ihrer Akquise App</span></div>
            <br>
            <div class="btn big-red link" @click="$scrollTo('#neuesbu')"><span>Mehr zur ERGO BU für junge Leute</span></div-->
          </div>
        </div>
        <div class="grid-x">
          <div class="cell large-offset-2 small-12 large-8 relative p-4">
            <h2 class="title-2 mt-5">Gestatten: Thore Schölermann, Schauspieler,
              <br>
              TV-Moderator – und Akquise-App-Pate.</h2>
            <p class="teaser-text">
              Für Ihre individuelle Akquise-App hat ERGO ein bekanntes Gesicht gewonnen. Millionen junger Menschen kennen Thore Schölermann – unter anderem als Moderator von taff, The Voice und The Voice Kids. Für Sie steht Thore nicht nur hinter der Change Your Life-Challenge, sondern auch hinter Ihnen. Sehen Sie selbst:
            </p>
          </div>
        </div>
        <div class="grid-x">
          <div class="cell large-offset-2 small-12 large-8 relative link" style="position:relative" @click="ui.showVidModal = true; $store.trackingClick('VideoThore_Abspielen');">
            <img src="@/assets/play_s.png" class="play-btn">
            <img class="center-block" src="@/assets/video_thumb.jpg" style="box-shadow: 0 2px 10px 1px rgba(0,0,0,0.6) "/>
          </div>
        </div>
      </div>
      </div>
      <div class="section-2 pt-10 bg-pink">
        <div class="grid-container fluid">
          <div class="grid-x">
            <div class="cell small-12 medium-offset-0 medium-4 large-offset-1 large-5 relative">
              <h1 class="big-title mt-1">Willkommen zu Thores Change Your Life-Challenge.</h1>
              <p class="teaser-text">Mit der Akquise-App schicken Sie ein wahres Dreamteam ins Rennen: Thore und The Cat sorgen dafür, dass sich junge Menschen spielerisch mit dem Thema Arbeitskraftsicherung befassen. Und empfehlen am Ende natürlich, sich von Ihnen persönlich zur Risikovorsorge beraten zu lassen. Wie das genau aussieht? Das können Sie hier testen.</p>
              <ul class='loading-frame mt-35 hide-for-small-only'>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
                <div class='circle'></div>
              </ul>
              <div class="arrow-container mt-20 hide-for-small-only">
                <span @click="$store.trackingClick('AkquiseAppTesten_Desktop');" class="big-text">Hier Akquise-App testen</span>
              </div>
              <a :href="state.app.appUrl + 'app/Max-Mustermakler'" target="_blank" @click="$store.trackingClick('AkquiseAppTesten_Mobile');"><div class="btn big-red link show-for-small-only app-test-btn"><span>Hier Akquise-App testen</span></div></a>
            </div>
            <div class="cell small-12 medium-offset-0 medium-8 large-6 relative hide-for-small-only iframe-wrapper">
              <!-- TODO iframe App -->
              <!--img class="center-block iframe-border" src="@/assets/Hand-mit-Schatten_375x667_innen4.png" /-->
              <img class="center-block iframe-border" src="@/assets/Hand-mit-Schatten_Mockup.png" />
              <a :href="state.app.appUrl + 'app/Max-Mustermakler?iframe=true'" target="_blank" class="show-for-ie"><img class="show-for-ie start-screen-img" src="@/assets/start_screen.jpg" /></a>
              <div class="iframe-black-bg"></div>
              <iframe class="iframe hide-for-ie" frameBorder="0" :src="state.app.appUrl + 'app/Max-Mustermakler?iframe=true'"></iframe>
              <!--img class="center-block" src="@/assets/shutterstock_1569218230_Handy_mit-Screen.png" /"-->
            </div>
          </div>
          <!--div class="grid-x">
            <div class="cell large-offset-2 small-12 large-7 relative center-block">
              <div class="btn big-red link" @click="$scrollTo('#appregister')"><span>Bereits überzeugt? Dann klicken Sie hier und erstellen Sie sich Ihre eigene App-Version.</span></div>
            </div>
          </div-->
        </div>
      </div>
      <div class="section-4 bg-pink">
        <div >
          <div class="grid-x">
            <div class="cell small-12 large-12 relative">
              <h1 class="title-1">Jetzt wird es aber Zeit durchzustarten. <br>Erstellen Sie sich hier Ihre eigene App-Version: </h1>
            </div>
          </div>
          <div class="grid-container fluid">
            <div class="grid-x grid-margin-x pb-10" id="appregister">
              <div class="cell small-12 medium-offset-0 medium-6 large-offset-1 large-5 relative hide-for-small-only">
                <img class="center-block" src="@/assets/Handy_mit-Screen_Eigene_App_Neu.png" />
              </div>
              <div class="cell small-12 medium-6 large-5 relative">
                <!-- TODO preview text -->
                <h1 class="big-title mt-1">Ihre eigene App: <br>Wie das geht? <br>Ganz einfach!</h1>
                <p class="teaser-text">Um Ihre Unabhängigkeit zu stärken, hat ERGO Thores Change Your Life-Challenge neutral gestaltet. Um Ihre eigene App-Version mit Ihren Kontaktdaten zu erstellen, müssen Sie lediglich ein paar Informationen eingeben, bestätigen – und Ihre E-Mails öffnen.</p>
                <div v-if="!ui.registerSuccess">
                  <!--
                  <div class="input-wrapper">
                    <input class="text-input" v-model="state.userData.forename" placeholder="Ihr Vorname">
                  </div>
                  <div class="input-wrapper">
                    <input class="text-input" v-model="state.userData.name" placeholder="Ihr Nachname">
                  </div>
                  <div class="input-wrapper">
                    <input class="text-input" v-tooltip="{ content: 'Berufsbezeichnung (wird in der App unter Ihrem Namen angezeigt)', classes: ['tooltip'], trigger: 'hover focus', hideOnTargetClick: false }" v-model="state.userData.customApp.description" placeholder="Berufsbezeichnung (wird in der App unter Ihrem Namen angezeigt)">
                  </div>
                  <div class="error err1 text-center"></div>
                  -->
                  <div class="show-for-small-only pt-20">
                    <!-- TODO preview text -->
                    <img class="center-block" src="@/assets/Handy_mit-Screen_Eigene_App_Neu.png" />
                  </div>
                  <div v-if="!$store.compHasCustomApp">
                    <div id="btnCreateApp" class="btn big-red create-app-btn link inline" @click="handleClickOnCreateApp()"><span>Jetzt eigene App-Version erstellen<span v-if="$store.compIsLoggedIn"><br>oder Daten bearbeiten</span></span></div>
                    <login-link id="loginlink">
                      Bereits eine App erstellt?
                    </login-link>
                  </div>
                  <div id="btnCreateApp" v-else class="btn big-red m-3 link" @click="handleClickOnCreateApp()"><span>Ihre Daten bearbeiten</span></div>
                </div>
                <div v-else>
                  <div class="mt-50">
                    <h2>Die Registrierungs-Mail wurde an Sie verschickt!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <transition name="fade">
            <div class="grid-x" id="extendedForm" v-show="ui.extendedFormVisible && !ui.registerSuccess">
              <div class="cell large-offset-2 small-12 large-8 relative">
                <div class="grid-container fluid">
                  <div class="form-wrapper">
                    <div class="grid-container fluid">
                      <div class="grid-x">
                        <div class="cell large-offset-2 small-12 large-8 relative">
                          <h2 class="title-2" v-if="!$store.compHasCustomApp">Bitte ergänzen Sie Ihre Angaben für die Erstellung Ihrer eigenen App-Version.</h2>
                          <h2 class="title-2" v-else>Hier bearbeiten Sie ihre Daten.</h2>
                        </div>
                      </div>
                      <!-- radio-buttons -->
                      <div class="grid-x negative-margin">
                        <div class="cell large-offset-3 small-6 large-3 relative radio-wrapper">
                          <input v-model="state.userData.salutation" type="radio" id="male" name="gender" value="Herr">
                          <label for="male">Herr</label>
                        </div>
                        <div class="cell small-6 large-3 relative radio-wrapper">
                          <input v-model="state.userData.salutation" type="radio" id="female" name="gender" value="Frau">
                          <label for="female">Frau</label>
                        </div>
                      </div>

                      <div class="grid-x">
                        <div class="cell large-offset-2 small-12 large-8 relative">
                          <div class="input-wrapper required">
                            <input class="text-input" v-model="state.userData.forename" placeholder="Vorname">
                          </div>
                          <div class="input-wrapper required">
                            <input class="text-input" v-model="state.userData.name" placeholder="Nachname">
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-tooltip="{ content: 'Berufsbezeichnung (wird in der App unter Ihrem Namen angezeigt)', classes: ['tooltip'], trigger: 'hover focus', hideOnTargetClick: false }" v-model="state.userData.customApp.description" placeholder="Berufsbezeichnung (wird in der App unter Ihrem Namen angezeigt)">
                          </div>
                          <div class="input-wrapper required">
                            <input class="text-input" :disabled="$store.compIsLoggedIn" v-model="state.userData.email" @blur="$v.state.userData.email.$touch()" placeholder="E-Mail">
                            <div v-if="$v.state.userData.email.$dirty && $v.state.userData.email.$invalid" class="input-error">E-Mail Adresse ungültig</div>
                          </div>
                          <div class="input-wrapper required" v-if="!$store.compIsLoggedIn">
                            <input class="text-input" @blur="$v.state.userData.emailConfirm.$touch()" v-model="state.userData.emailConfirm" placeholder="E-Mail (Wiederholung)">
                            <div v-if="$v.state.userData.emailConfirm.$dirty && $v.state.userData.emailConfirm.$invalid" class="input-error">E-Mail-Adressen stimmen nicht überein</div>
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.companyName" placeholder="Firmenname">
                          </div>

                          <!-- Straße Hausnummer -->
                          <div class="grid-x">
                            <div class="cell small-12 large-7 relative">
                              <div class="input-wrapper required">
                                <input class="text-input" v-model="state.userData.street" placeholder="Straße">
                              </div>
                            </div>
                            <div class="cell large-offset-1 small-12 large-4 relative">
                              <div class="input-wrapper required">
                                <input class="text-input" v-model="state.userData.streetNumber" placeholder="Nr.">
                              </div>
                            </div>
                          </div>

                          <!-- PLZ Ort -->
                          <div class="grid-x">
                            <div class="cell small-12 large-4 relative">
                              <div class="input-wrapper required">
                                <input class="text-input" v-model="state.userData.zip" placeholder="PLZ">
                              </div>
                            </div>
                            <div class="cell large-offset-1 small-12 large-7 relative">
                              <div class="input-wrapper required">
                                <input class="text-input" v-model="state.userData.city" placeholder="Ort">
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>

                      <div class="grid-x">
                        <div class="cell large-offset-2 small-12 large-8 relative mt-20 mb-20" v-if="$store.compIsLoggedIn && !$store.compHasCustomApp">
                          <div>
                            <div v-if="!ui.registerInProgress" id="btnCreateApp2" class="btn big-red link" :class="{'btn-disabled': compEditTopFormBtnDisabled}" @click="saveBrokerDataOnly()"><span>Daten Speichern und keine App erstellen</span></div>
                            <spinner v-else :size="'medium'"></spinner>
                          </div>
                        </div>
                        <div class="cell large-offset-2 small-12 large-8 relative">
                          <h2 class="title-2 mt-25">Bitte geben Sie an, wie potenzielle Kunden Sie kontaktieren können.</h2>
                        </div>
                      </div>
                      <!-- Kontaktdaten -->
                      <div class="grid-x">
                        <div class="cell large-offset-2 small-12 large-8 relative">
                          <div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.customApp.contactTel" placeholder="Ihre Telefon-/Handynummer">
                          </div>
                          <!--div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.customApp.contactMobile" placeholder="Ihre Mobilfunknummer für WhatsApp-Anfragen">
                          </div-->
                          <div class="input-wrapper required">
                            <input class="text-input" v-model="state.userData.customApp.contactEmail" @blur="$v.state.userData.customApp.contactEmail.$touch" placeholder="Ihre E-Mail-Adresse">
                            <div v-if="$v.state.userData.customApp.contactEmail.$dirty && $v.state.userData.customApp.contactEmail.$invalid" class="input-error">E-Mail Adresse ungültig</div>
                          </div>
                          <div class="input-wrapper" v-if="1==2">
                            <input class="text-input" v-model="state.userData.customApp.contactEmailConfirm" @blur="$v.state.userData.customApp.contactEmailConfirm.$touch" placeholder="Ihre E-Mail-Adresse (Wiederholung)">
                            <div v-if="$v.state.userData.customApp.contactEmailConfirm.$dirty && $v.state.userData.customApp.contactEmailConfirm.$invalid" class="input-error">E-Mail-Adressen stimmen nicht überein</div>
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.customApp.skype" placeholder="Ihr Skypename">
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.customApp.facebook" placeholder="Link zu Ihrem Facebook-Profil">
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-tooltip="{ content: 'Bitte geben sie die Adresse mit https:// an.', classes: ['tooltip'], trigger: 'hover focus', hideOnTargetClick: false }" v-model="state.userData.customApp.website" placeholder="Ihre Webseite">
                          </div>
                          <div class="input-wrapper">
                            <input class="text-input" v-model="state.userData.customApp.instagram" placeholder="Link zu Ihrem Instagram-Profil">
                          </div>
                        </div>
                      </div>

                      <!-- checkboxes -->
                      <div class="grid-x">
                        <div class="cell large-offset-2 small-12 large-8 relative checkbox-wrapper">
                          <div v-if="compEditTermsVisible">
                            <input type="checkbox" v-model="terms.acceptPartner" id="acceptPartner" name="partnerbedinungen" value="acceptPartner">
                            <label for="acceptPartner">Ich akzeptiere die <router-link to="partnerbedingungen" target="_blank">Partnerbedingungen</router-link>.</label>
                          </div>
                          <div v-if="$store.compShowAcceptContact">
                            <input type="checkbox" v-model="state.userData.acceptContact" id="acceptContact" name="kontaktaufnahme" value="acceptContact">
                            <label for="acceptContact">Ich erlaube ERGO die Kontaktaufnahme mit mir.</label>
                          </div>
                          <div v-if="compEditTermsVisible">
                            <input type="checkbox" v-model="terms.acceptPrivacy" id="acceptDatenschutz" name="datenschutz" value="acceptDatenschutz">
                            <label for="acceptDatenschutz">Ich akzeptiere die <router-link to="datenschutz" target="_blank">Datenschutzbestimmungen</router-link> und willige in die Verarbeitung meiner Daten zur Kontaktaufnahme und Erstellung der personalisierten App ein.</label>
                          </div>
                          <div v-if="ui.clickedOnSendBtn && !state.userData.acceptContact">
                            <p style="font-weight:bold" class="mt-20">
                              Dürfen wir Sie auch künftig mit unseren Angeboten und Vertriebsservices kontaktieren?
                            </p>
                            <!-- radio-buttons -->
                            <div class="grid-x mt-15 mb-40">
                              <div class="cell small-6 large-3 relative radio-wrapper">
                                <input v-model="state.userData.acceptContact" id="accepptYes" type="radio" :value="true">
                                <label for="accepptYes">Ja</label>
                              </div>
                              <div class="cell small-6 large-3 relative radio-wrapper">
                                <input v-model="state.userData.acceptContact" id="accepptNo" type="radio" :value="false">
                                <label for="accepptNo">Nein</label>
                              </div>
                            </div>
                          </div>

                          <p v-if="!$store.compHasCustomApp">Bitte beachten Sie: dieser Service richtet sich exklusiv an Versicherungsvermittler.</p>
                          <p v-if="$v.state.userData.$invalid" class="error-msg">Bitte füllen Sie das Formular aus.</p>
                          <p v-if="$v.terms.$invalid && compEditTermsVisible" class="error-msg">Bitte akzeptieren Sie noch die o.g. Bedingungen.</p>
                        </div>
                      </div>

                      <div class="grid-x mt-10">
                        <div class="cell large-offset-3 small-12 large-6 relative">
                          <div v-if="!compIsEditMode">
                            <div v-if="!ui.registerInProgress" id="btnCreateApp2" class="btn big-red link" :class="{'btn-disabled': compRegisterWithAppBtnDisabled}" @click="registerApp()"><span>Jetzt eigene App-Version erstellen</span></div>
                            <spinner v-else :size="'medium'"></spinner>
                          </div>
                          <div v-else>
                            <div v-if="!ui.registerInProgress" id="btnCreateApp2" class="btn big-red link" :class="{'btn-disabled': compEditBtnDisabled}" @click="editApp(); $store.trackingClick('AppDatenSpeichern');"><span>Speichern</span></div>
                            <spinner v-else :size="'medium'"></spinner>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>
    <!-- </div> -->
      </div>
      <div class="section-3">
        <div class="grid-container fluid">
          <div class="grid-x">
            <div class="cell large-offset-2 small-12 large-8 relative p-4">
              <h2 class="title-2 mt-5">Sie erhalten Ihre eigene App – mit direkt eingebauter Marketingunterstützung.</h2>
              <div class="teaser-text">
                Wir haben Thores Change Your Life-Challenge so programmiert, dass Sie Ihre App ganz einfach in den wichtigsten sozialen Medien, per E-Mail und auf Ihrer Website vermarkten können. Schließlich wollen Sie viele junge Menschen ansprechen – und zwar erfolgreich. Die App ist vermarktungsfertig für:
              </div>
            </div>
          </div>
          <div class="grid-x">
            <div class="cell large-offset-2 small-12 large-8 relative p-4">
              <div class="grid-x align-center">
                <div class="cell small-4 large-2 relative sm-icons text-center">
                  <div class="icon facebook inline">
                    <img src="../assets/icons/ERGO_Icon_black_Facebook.svg">
                  </div>
                  <div class="icon-text">Facebook</div>
                </div>
                <div class="cell small-4 large-2 relative sm-icons text-center">
                  <div class="icon instagram inline">
                    <img class="instagram-padding" src="../assets/icons/instagram.svg">
                  </div>
                  <div class="icon-text">Instagram</div>
                </div>
                <div class="cell small-4 large-2 relative sm-icons text-center">
                  <div class="icon whatsapp inline">
                    <img src="../assets/icons/ERGO_Icon_black_Whatsapp.svg">
                  </div>
                  <div class="icon-text">WhatsApp</div>
                </div>
                <div class="cell small-4 large-2 relative sm-icons text-center">
                  <div class="icon email inline">
                    <img src="../assets/icons/ERGO_Icon_black_at_Zeichen.svg">
                  </div>
                  <div class="icon-text">E-Mail</div>
                </div>
                <div class="cell small-4 large-2 relative sm-icons text-center">
                  <div class="icon website inline">
                    <img src="../assets/icons/ERGO_Icon_black_Laptop.svg">
                  </div>
                  <div class="icon-text">Website</div>
                </div>
              </div>
              <div class="sm-preview hide-for-small-only">
                <img src="@/assets/social_post.png" />
              </div>
              <div class="sm-preview show-for-small-only">
                <img src="@/assets/social_post_mob.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import infoModal from '@/components/infoModal.vue'
import loginLink from '@/components/loginLink.vue'
import { required, requiredIf, email, sameAs } from 'vuelidate/lib/validators'
import Spinner from 'vue-simple-spinner'
import videoModal from '@/components/youtube_modal.vue'

const confirmEmailValidation = (value, vm) => {
  console.log(value, vm)
};

export default {
  name: 'AppTeaser',
  components: {
    infoModal, Spinner, loginLink, videoModal
  },
  data() {
    return {
      state: this.$store.state,
      ui: {
        registerSuccess: false,
        extendedFormVisible: false,
        registerInProgress: false,
        clickedOnSendBtn: false,
        showRegisterSuccessModal: false,
        showVidModal: false
      },
      //TODO: Validation on Submit, Error Messages, Api Calls
      terms: {
        acceptPartner: false,
        acceptPrivacy: false,
      }
    }
  },
  computed: {
    compEditTopFormBtnDisabled() {
      if (this.$v.state.userData.forename.$invalid) return true
      if (this.$v.state.userData.name.$invalid) return true
      if (this.$v.state.userData.email.$invalid) return true
      return false
    },
    compRegisterWithAppBtnDisabled() {
      if (this.$v.state.userData.$invalid) return true
      if (this.$v.terms.$invalid) return true
      return false
    },
    compEditBtnDisabled() {
      if (this.$v.state.userData.$invalid) return true
      return false
    },
    compEditTermsVisible() {
      if (this.$store.compHasCustomApp) return false
      return true
    },
    compIsEditMode() {
      if (this.$store.compHasCustomApp) return true
      return false
    },
    compIsLoggedIn() {
      if (this && this.$store && this.$store.compIsLoggedIn) return true
      else return false
    }
  },
  validations: {
    terms: {
      acceptPartner: {
        sameAs: sameAs( () => true )
      },
      acceptPrivacy: {
        sameAs: sameAs( () => true )
      },
    },
    state: {
      terms: {
        acceptPartner: {
          sameAs: sameAs( () => true )
        },
        acceptPrivacy: {
          sameAs: sameAs( () => true )
        },
      },
      userData: {
        salutation: {
          required
        },
        forename: {
          required
        },
        name: {
          required
        },
        street: {
          required
        },
        streetNumber: {
          required
        },
        zip: {
          required
        },
        city: {
          required
        },
        email: {
          required,
          email
        },
        emailConfirm: {
          function(m, c) {
            if (!this.compIsLoggedIn) {
              console.log(m, c)
              if (c.email === c.emailConfirm) return true
              else return false
            }
            else return true
          }
        },
        customApp: {
          contactEmail: {
            required,
            email
          }
        },
      },
    }
  },
  mounted() {
    
  },
  methods: {
    printValid() {
      console.log(this.$v)
    },
    async handleClickOnCreateApp() {
      this.ui.extendedFormVisible = 1
      await this.$sleep(600)
      this.$scrollTo('#extendedForm')
      this.$store.trackingView("app_extended_form");
    },
    async saveBrokerDataOnly() {
      if (this.compEditTopFormBtnDisabled) return false
      this.ui.registerInProgress = true
      await this.$sleep(500)
      let result
      let model = Object.assign({}, this.state.userData)
      model.customApp = {}
      try {
        result = await this.$store.editApp(model)
      } catch(err) {
        console.log('err', err.response)
        await this.$fire({
          title: "Fehler",
          text: "Entschuldigung, leider ist etwas schiefgelaufen. Folgende Fehlermeldung könnte weiterhelfen: " + err.response.data.message,
          type: "error"
        })
        this.ui.registerInProgress = false
        return
      }
      this.ui.registerInProgress = false
      await this.$fire({
        title: "Speichern erfolgreich!",
        type: "success",
        timer: 3000
      })
      this.state.app.savedForm = true
    },
    async registerApp() {
      if (this.compRegisterWithAppBtnDisabled) return false
      if (!this.ui.clickedOnSendBtn && !this.state.userData.acceptContact) {
        this.ui.clickedOnSendBtn = true
        return
      }
      this.ui.registerInProgress = true
      await this.$sleep(500)
      let result
      try {
        result = await this.$store.registerWithApp(this.state.userData)
      } catch(err) {
        console.log('err', err.response)
        await this.$fire({
          title: "Fehler",
          text: "Entschuldigung, leider ist etwas schiefgelaufen. Folgende Fehlermeldung könnte weiterhelfen: " + err.response.data.message,
          type: "error"
        })
        this.ui.registerInProgress = false
        return
      }
      this.ui.registerInProgress = false
      /*
      await this.$fire({
        title: "Registrierung erfolgreich!",
        text: "Super, fast geschafft! Jetzt nur noch auf den Link klicken, den wir Ihnen per E-Mail geschickt haben und ihr Account wird freigeschaltet.",
        type: "success"
      })
      */
     //if logged in dont show success messages for registration, but for creation of the app
     if (this.$store.compIsLoggedIn) {
        await this.$fire({
          title: "App erstellt!",
          type: "success"
        })
        this.$store.login()
     } else {
        await this.$fire({
          title: "Sie haben Post!",
          text: "Zur Bestätigung Ihrer Kontaktdaten haben wir Ihnen eine E-Mail geschickt. Bitte prüfen Sie auch Ihren Spam-Ordner.",
          type: "success"
        })
        this.ui.registerSuccess = true
        //this.ui.showRegisterSuccessModal = true
        this.state.app.registerWithAppSuccess = true
        this.state.app.savedForm = true
     }
      this.$scrollTo('#appregister')
    },
    async editApp() {
      if (this.compEditBtnDisabled) return false
      if (!this.ui.clickedOnSendBtn && !this.state.userData.acceptContact) {
        this.ui.clickedOnSendBtn = true
        return
      }
      this.ui.registerInProgress = true
      await this.$sleep(500)
      let result
      try {
        result = await this.$store.editApp(this.state.userData)
      } catch(err) {
        console.log('err', err.response)
        await this.$fire({
          title: "Fehler",
          text: "Entschuldigung, leider ist etwas schiefgelaufen. Folgende Fehlermeldung könnte weiterhelfen: " + err.response.data.message,
          type: "error"
        })
        this.ui.registerInProgress = false
        return
      }
      this.ui.registerInProgress = false
      await this.$fire({
        title: "Speichern erfolgreich!",
        type: "success",
        timer: 3000
      })
      this.state.app.savedForm = true
    }
  }
}
</script>

<style lang="stylus" scoped>
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .hide-for-ie {
    display:none!important
  }
  .show-for-ie {
    display:block!important
  }
}
.hide-for-ie {
  
}
.show-for-ie {
  display:none
}
.create-app-btn {
  margin-top: 1em
  margin-bottom:2em
}
.start-screen-img {
  width:317px
  height:600px
  position:absolute;
  z-index:1
  top:48px
  left:2px
  right:0
  margin 0 auto
}
.iframe-wrapper {
  transform: scale(0.9) //iframe: 0.8
  transform-origin:top
}
.iframe-border {
  position:relative
  //width:493px
  z-index:2
  pointer-events: none;
  //height:733px
}
.iframe-black-bg {
  top:26px
  background-color:black
  position:absolute;
  margin: 0 auto
  left: 0
  right: 0
  width:308px
  height:641px
}
.iframe {
  position:absolute
  //left: 0
  //right: 0
  margin 0 auto
  //top:33px
  //height:770px
  //width:358px
  z-index:1
  right:0
  //width:375px
  //height:667px
  width:317px
  height:600px
  top:60px
  left:2px
}
.required {
  &:after {
    content: '*'
    color: #8e0038
    font-size: 24px
    position:absolute
    top:-5px
    right:-14px
  }
}
.inline {
  display: inline-block
}
.play-btn {
  position: absolute;
  top: 50%;
  opacity:0.7
  transform: translateY(-50%);
  /* add code below to also center horizontally */
  left:0;
  right:0;
  margin: 0 auto;
}
.btn-disabled {
  opacity:0.7
}

.section-1,
.section-2,
.section-3,
.section-4 {
  @media screen and (max-width: 39.9375em) {
    padding 0 1em
  }
}

.section-4 {
  padding-bottom:90px!important
  @media screen and (max-width: 39.9375em) {
    padding-bottom: 40px!important
  }
}

.section-2 {
  // height 62.3em
  //padding-bottom: 135px!important
  padding-bottom:0px!important
  .big-title {
    font-size 3.43em
    color #8E0038
    line-height: 1.2
    font-family: 'FedraSerifAPro'
    font-weight bold

    @media screen and (max-width: 39.9375em) {
      font-size 2.17em
    }
  }

circle-size = 15px
dot-color = #8e0038
light-dot-color = #fff

.loading-frame {
  position: relative;
  left: 45%;
  height:70px
}
.app-test-btn {
  margin-top: 30px!important
  margin-bottom: 40px!important
  position:relative!important
}
.circle {
  position: absolute;
  height: circle-size;
  width: circle-size;
  border-radius: circle-size;
  background-color: dot-color;
  animation: animate linear 2s infinite;
}

.circle:nth-child(1) {
  animation-delay: 0.9s;
}

.circle:nth-child(2) {
  animation-delay: 1.1s;
  transform: translate(18px,13px);
}

.circle:nth-child(3) {
  animation-delay: 1.3s;
  transform: translate(35px,25px);
}

.circle:nth-child(4) {
  animation-delay: 1.1s;
  transform: translate(18px,38px);
}

.circle:nth-child(5) {
  animation-delay: 0.9s;
  transform: translate(0px, 50px);
}

.circle:nth-child(6) {
  animation-delay: 0.9s;
  transform: translate(0,25px);
}

.circle:nth-child(7) {
  animation-delay: 0.7s;
  transform: translate(-20px,25px);
}

.circle:nth-child(8) {
  animation-delay: 0.5s;
  transform: translate(-40px,25px);
}

.circle:nth-child(9) {
  animation-delay: 0.3s;
  transform: translate(-60px,25px);
}

.circle:nth-child(10) {
  animation-delay: 0.1s;
  transform: translate(-80px,25px);
}

@keyframes animate {
  0%, 100% {
    background-color: dot-color;
  }
  50% {
    background-color: light-dot-color;
  }
}


  .arrow-container {
    //padding 1.5em 3.4em
    //border .15em solid #8E0038
    position: relative;

    @media screen and (max-width: 39.9375em) {
      margin-bottom 5em
    }

    /* TODO pfeil bauen */

    .big-text {
      font-size 3.14em
      font-weight bold
      color #8E0038

      @media screen and (max-width: 39.9375em) {
        font-size 2.17em
      }
    }
  }

  .btn {
    &.big-red {
      border-radius 4em
      box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)
      
      span {
        font-size 2em
        @media screen and (max-width: 39.9375em) {
          font-size 1.14em
        }
      }
    }
    position absolute
    margin-top 4.8em
  }
}

.sm-icons {
  margin 2.4em 0
  text-align:center

  .icon {
    width 3.5em
    height 3.5em
  }
  .icon-text {
    padding-top:9px
  }
}

.section-3 {
  padding-bottom 10em
  @media screen and (max-width: 39.9375em) {
    padding-bottom 3em
  }
}

.section-4 {
  .title-1 {
    font-weight bold
    background-color #8e0038
    color #fff
    text-align center
    padding 1.5em 0
    margin-bottom 2.5em

    @media screen and (max-width: 39.9375em) {
      padding 1.5em 1em
      margin 0 -.5em
    }
  }

  .big-title {
    font-weight bold
    color #8e0038
    line-height: 1.2
    font-family: 'FedraSerifAPro'

    @media screen and (max-width: 39.9375em) {
      margin 2em 0 1.3em
    }
  }
}

.form-wrapper {
  margin 7em 0 2.3em
  background-color #fff
  border-radius .3em
  padding 5.3em 1em 8.5em
  box-shadow: 0 1em 1em .1em rgba(0,0,0,0.5);

  .text-input {
    border .1em solid #807E6F
  }

  .error-msg {
    text-align center
    color #BF1528
  }
}

.m-3 {
  margin 3em 0
}

.negative-margin {
  margin -1em 0 2em
}

.radio-wrapper {
  display flex
  justify-content center
}

.checkbox-wrapper {
  margin-top 2em
}

.input-wrapper {
  position:relative
  margin-bottom 1.3em
}

input {
  width 100%
  padding 1em 1.4em
  border-radius .35em
  border 0
  font-weight bold

  &::placeholder {
    color #807E6F
    font-weight bold
  }
}

.sm-preview {
  margin-top:1.3em
  //background-color #D9D5C7
  width 100%
  //height 50em
}

.bg-pink {
  background-color #E4D6E4
}

.relative {
  position relative
}

.mt-1 {
  margin-top 1em
  @media screen and (max-width: 39.9375em) {
    margin-top 0
  }
}

.mt-5 {
  margin-top 5em

  @media screen and (max-width: 39.9375em) {
    margin-top 2em
  }
}

.pt-10 {
  padding-top 10em
  padding-bottom: 10em
  @media screen and (max-width: 39.9375em) {
    //padding 3em 1em 8.5em
    padding-top 3em
    padding-bottom: 8.5em
  }
}

.gird-container {
  width: 50em
}

.p-120 {
  padding-top 10em
  padding-bottom 10em
  
  @media screen and (max-width: 39.9375em) {
    padding-top 3.3em
    padding-bottom 3.3em
  }
}

.p-4 {
  padding 0 4em;
  @media screen and (max-width: 39.9375em) {
    padding 0
  }
}

.center-block {
  display block
  margin 0 auto
}

.title-2 {
  font-size 2em
  font-weight bold
  color #000
  line-height 1.4em
  text-align center
  margin-bottom 1.6em

  @media screen and (max-width: 39.9375em) {
    margin-bottom 1.3em
  }

  &.mt-5 {
    margin-top 5em
    
    @media screen and (max-width: 39.9375em) {
      margin-top 3.5em
    }
  }
}

img.app-teaser {
  display block
  width 20.5em
  margin 0 5em 0 auto
  border-radius 1.6em
  //box-shadow: 0 .7em 1.1em .25em rgba(0,0,0,.4);
  
  @media screen and (max-width: 39.9375em) {
    margin 0 auto 3em
  }
}

.teaser-text {
  font-size 1.14em
  color #000
}

.btn {
  &.big-red {
    background-color #BE1528
    padding 1.1em 3.2em
    text-align center
    border-radius 2em
    box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)

    span {
      font-size 1.14em
      color #ffffff
      font-weight bold
    }
  }
}

</style>